import { Component, ContentChild } from '@angular/core';
import { MatInput } from '@angular/material/input';

@Component({
  selector: 'app-show-hide-password',
  templateUrl: './show-hide-password.component.html',
  styleUrls: ['./show-hide-password.component.scss']
})
export class ShowHidePasswordComponent {
  /**
   * Value to show an icon or another
   */
  showPassword = false;

  /**
   * Input where you want to put the hidden password logic
   */
  @ContentChild(MatInput) input!: MatInput;

  /**
   * This method show the correct icon and change the password type to show the password or not
   */
  toggleShow(): void {
    this.showPassword = !this.showPassword;
    this.input.type = this.showPassword ? 'text' : 'password';
  }
}
